import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PrimaryButton } from '../components/Common/PrimaryButton';

export const Error404 = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
        textAlign: 'center',
      }}
    >
      <h1
        style={{
          fontSize: '120px',
          margin: '0',
          color: '#2c3e50',
          fontWeight: 'bold',
        }}
        data-aos="fade"
      >
        404
      </h1>
      <h2
        style={{
          fontSize: '30px',
          margin: '20px 0',
          color: '#34495e',
        }}
        data-aos="fade"
      >
        Page Not Found
      </h2>
      <p
        style={{
          fontSize: '18px',
          color: '#7f8c8d',
          marginBottom: '30px',
          maxWidth: '500px',
        }}
        data-aos="fade"
      >
        The page you are looking for might have been removed, had its name changed,
        or is temporarily unavailable.
      </p>
      <PrimaryButton label={"Back to Home"} onClick={() => navigate('/')} />
    </div>
  );
};